import {Button, ButtonProps, useListContext, useUnselectAll, useUpdateMany,} from "react-admin";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";

export const NotComplededBulkButton = (props: ButtonProps) => {
  const { selectedIds, refetch } = useListContext();
  const unselect = useUnselectAll("carrier_cashboxes");
  const [update] = useUpdateMany("carrier_cashboxes", selectedIds, { completed: false });
  const handleSubmit = () => {
    update();
    unselect();
    refetch();
  };

  return (
    <Button
      {...props}
      disabled={selectedIds.length <= 0}
      label="Non complete"
      onClick={handleSubmit}
    >
      <VisibilityOffIcon />
    </Button>
  );
};
